// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2c95a6f9] .el-form-item__label {\n  padding: 0 12px 0 0;\n}", ""]);
// Exports
module.exports = exports;
